import { useEffect, useRef } from "react";

/* Enquanto a tela de um Pix está aberta e visível (pedidos, loja e PDV),
   pergunta ao servidor se o pagamento já caiu, sem depender do aviso
   (webhook) do provedor: a cada 5 s por até 10 min — 120 consultas, dentro
   do limite do servidor (200 a cada 10 min por conta). Depois disso, a
   conferência agendada do servidor continua. Para sozinha quando `ativo`
   vira false (pago, tela fechada). Falhas são silenciosas: o botão
   "Verificar pagamento" continua na tela. */
export function useVerificacaoAutomatica(ativo, verificar, { intervalo = 5000, duracao = 10 * 60000 } = {}) {
  const fn = useRef(verificar);
  useEffect(() => { fn.current = verificar; });

  useEffect(() => {
    if (!ativo) return undefined;
    const inicio = Date.now();
    let vivo = true;
    let timer;
    const agendar = () => {
      if (vivo && Date.now() - inicio < duracao) timer = setTimeout(rodar, intervalo);
    };
    const rodar = async () => {
      if (!vivo || Date.now() - inicio >= duracao) return;
      if (document.visibilityState !== "hidden") {
        try { await fn.current(); } catch { /* o botão continua disponível */ }
      }
      agendar();
    };
    agendar();
    return () => { vivo = false; clearTimeout(timer); };
  }, [ativo, intervalo, duracao]);
}
